/**
 * Money + date formatting helpers.
 * All amounts in the DB are integer cents. In the UI we render as dollars.
 */

export function fmtMoney(cents: number, opts: { sign?: boolean } = {}): string {
  const abs = Math.abs(cents) / 100;
  const s = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(abs);
  if (opts.sign) {
    if (cents > 0) return `+${s}`;
    if (cents < 0) return `−${s}`;
    return s;
  }
  return cents < 0 ? `−${s}` : s;
}

export function fmtDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function fmtShortDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function fmtTime(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
}

export function todayISO(): string {
  // Local ISO date (YYYY-MM-DD) in browser TZ
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function yesterdayISO(): string {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function flagReasonLabel(reason: string): string {
  switch (reason) {
    case 'new_merchant':       return 'New merchant';
    case 'outlier_amount':     return 'Unusually large';
    case 'uncategorized':      return 'Needs a category';
    case 'possible_duplicate': return 'Possible duplicate';
    case 'off_hours':          return 'Off-hours charge';
    default: return reason;
  }
}
